import React from "react";
import { HistorialDelCatalogo } from "./HistorialDelCatalogo";

interface Props {
  /**
   * El `entity_id` de Magento, o el SKU en un alta que todavía no lo tiene. El historial de
   * un producto vive partido entre los dos —el borrador se ancla en el SKU— y es el backend
   * el que junta los anclajes. Sin ninguno, en un alta que todavía no se guardó, el
   * historial se ve vacío (xcons-docs#499).
   */
  entityId?: string | number;
}

/**
 * El historial del producto. Es el de todo el Catálogo con `module="product"`: se generalizó en
 * `HistorialDelCatalogo` (xcons-docs#436) y éste queda para que la ficha y la revisión de
 * pendientes no tengan que saber el nombre del módulo.
 */
export const HistorialDelProducto: React.FC<Props> = ({ entityId }) => (
  <HistorialDelCatalogo module="product" entityId={entityId} />
);
